/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { withRouter, useHistory, RouteComponentProps } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";

import BackButtonLayout from "core/layouts/backButtonLayout";

import { useStyles } from "./styles";

interface FailProps {
  hideFail?: () => void;
}
const Fail = (props: FailProps) => {
  const { t, i18n } = useTranslation();
  const { hideFail } = props;
  const win: any = window;
  // const history = useHistory();
  const thanksUrl = win["contactus_thanks_url"];
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const theme = useTheme();

  return (
    <BackButtonLayout>
      <Grid container direction="column">
        <Grid item sm={6} xs={12}>
          <Typography component={"span"} variant={"body2"}>
            <Box
              fontWeight={700}
              style={{
                direction: langDir,
              }}
              fontSize={theme.spacing(4)}
              mb={theme.spacing(0)}
              letterSpacing={1}
            >
              {t("opps")}
            </Box>
          </Typography>
          <Typography component={"span"} variant={"body2"}>
            <Box
              fontWeight={700}
              style={{
                direction: langDir,
              }}
              fontSize={theme.spacing(4)}
              mb={theme.spacing(1)}
              letterSpacing={1}
            >
              {t("contactFailTitle")}
            </Box>
          </Typography>
          <PrimaryButton
            mb={theme.spacing(1)}
            disabled={false}
            loading={false}
            title={t("GobacktoContactus")}
            action={() => (hideFail ? hideFail() : {})}
          ></PrimaryButton>
          <TextButton
            action={() => {
              window.sessionStorage.thanksMessage = t("success_message");
              document.location.href = thanksUrl;
            }}
            disabled={false}
            loading={false}
            title={t("GobacktoHomepage")}
          ></TextButton>
        </Grid>
      </Grid>
    </BackButtonLayout>
  );
};
export default Fail;

interface PrimaryButtonProps {
  disabled?: boolean;
  loading?: boolean;
  mb?: number;
  action?: () => void;
  title: string;
}
const PrimaryButton = (props: PrimaryButtonProps) => {
  const { disabled, loading, title, mb, action } = props;
  const { t, i18n } = useTranslation();
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Button
      type="submit"
      variant="contained"
      color="secondary"
      style={{
        marginBottom: mb,
      }}
      className={classes.button}
      disabled={disabled}
      onClick={() => (action ? action() : {})}
      endIcon={
        !isRTL ? (
          <ArrowForwardIcon
            style={{ color: "#fff", cursor: "pointer" }}
            fontSize={"default"}
          />
        ) : (
          <ArrowBack
            style={{ color: "#fff", cursor: "pointer" }}
            fontSize={"default"}
          />
        )
      }
    >
      <Box mr={8} color={"white"}>
        {title}
      </Box>
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </Button>
  );
};
const TextButton = (props: PrimaryButtonProps) => {
  const { disabled, loading, title, action } = props;
  const { t, i18n } = useTranslation();
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Button
      type="submit"
      variant="contained"
      className={classes.textbutton}
      disabled={disabled}
      onClick={() => (action ? action() : {})}
      endIcon={
        !isRTL ? (
          <ArrowForwardIcon
            style={{ color: "#008CFF", cursor: "pointer" }}
            fontSize={"default"}
          />
        ) : (
          <ArrowBack
            style={{ color: "#008CFF", cursor: "pointer" }}
            fontSize={"default"}
          />
        )
      }
    >
      <Box mr={8} color={"#008CFF"}>
        {title}
      </Box>
      {loading && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </Button>
  );
};
